/**
 * Received customer cheques (BE-21) — real API.
 * A cheque tops up the customer's wallet as a pending credit; clearing it credits the wallet and the deposit bank.
 */

import ApiService from '../api.service';
import { keysCamelToSnake, unwrapData, unwrapPage } from '../../utils/apiConvert';

const clean = (obj) => Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== '' && v !== undefined));

export const receivedChequeService = {
  // params: { status (RECEIVED | CLEARED | BOUNCED | RETURNED), internalOrganizationId, q, from, to, page, size }
  list: async (params = {}) =>
    unwrapPage(await ApiService.get('/api/received-cheques', { params: clean(params) })),

  // { totalCount, pendingAmount, pendingCount, clearedAmount, bouncedCount }
  summary: async () => unwrapData(await ApiService.get('/api/received-cheques/summary')),

  // data: { internalOrganizationId, chequeNumber, chequeDate, drawerBank, amount }
  receive: async (data) => unwrapData(await ApiService.post('/api/received-cheques', keysCamelToSnake(clean(data)))),

  clear: async (id, date, bankAccountId) =>
    unwrapData(await ApiService.post(`/api/received-cheques/${id}/clear`, keysCamelToSnake({ date, bankAccountId }))),

  // bankCharge + bankAccountId are optional: the deposit bank's bounce fee
  bounce: async (id, { date, reason, bankCharge, bankAccountId }) =>
    unwrapData(await ApiService.post(`/api/received-cheques/${id}/bounce`,
      keysCamelToSnake(clean({ date, reason, bankCharge, bankAccountId })))),

  returnToCustomer: async (id, reason) =>
    unwrapData(await ApiService.post(`/api/received-cheques/${id}/return`, { reason })),
};

export default receivedChequeService;
